<template>
  <v-list class="admin-toolbar py-0" style="overflow: auto; height: calc(100vh - 64px)">
    <Dashboard />
    <Students v-if="$auth.policies['view-student-group']" />
    <Teachers v-if="$auth.policies['view-teacher-group']" />
    <Classes v-if="$auth.policies['view-class-group']" />
    <BoardingClasses v-if="$auth.policies['view-boarding-class-group']" />
    <TimeTables v-if="$auth.policies['view-schedule-group']" />
    <Exam v-if="$auth.policies['view-exam-list']" />
    <DraftTimeTables v-if="$auth.policies['view-schedule-group-draft']" />
    <!-- <ManagerDocuments v-if="$auth.policies['view-document-group']" />
    <Documents v-if="$auth.policies['view-document-group']" /> -->
    <DocDocAdmin v-if="$auth.policies['view-teacher-doc']" />
    <TuitionFee v-if="$auth.policies['view-tuition-fee-group']" />
    <Balance v-if="$auth.policies['view-student-credit-manager']" />
    <BusServices v-if="$auth.policies['view-bus-group']" />
    <DishServices v-if="$auth.policies['view-dish-service-group']" />
    <UniformServices v-if="$auth.role.type === 'manager'" />
    <Posts v-if="$auth.policies['view-contactBook-group']" />
    <Feedback v-if="$auth.policies['view-feedback-group']" />
    <Events v-if="$auth.policies['view-others-group']" />
    <Ticket v-if="$auth.policies['view-student-ticket']" />
    <AdvanceSetting v-if="$auth.policies['view-advance-group']" />
    <Settings v-if="$auth.policies['view-setting-group']" />
  </v-list>
</template>
<script>
import BusServices from '@/components/basic/menu/BusServices'
import DishServices from '@/components/basic/menu/DishServices'
import Classes from '@/components/basic/menu/Classes'
import TimeTables from '@/components/basic/menu/TimeTables'
import DraftTimeTables from '@/components/basic/menu/DraftTimeTables'
import Students from '@/components/basic/menu/Students.vue'
import Teachers from '@/components/basic/menu/Teachers.vue'
import Dashboard from '@/components/basic/menu/Dashboard'
import AdvanceSetting from '@/components/basic/menu/AdvanceSetting.vue'
import Settings from '@/components/basic/menu/Settings.vue'
import Posts from '@/components/basic/menu/Posts.vue'
import Feedback from '@/components/basic/menu/Feedback.vue'
import Ticket from '@/components/basic/menu/Ticket.vue'
// import Documents from '@/components/basic/menu/Documents.vue'
// import ManagerDocuments from '@/components/basic/menu/ManagerDocuments.vue'
import TuitionFee from '@/components/basic/menu/TuitionFee.vue'
import DocDocAdmin from '../basic/menu/DocDocAdmin.vue'
import Balance from '@/components/basic/menu/StudentCredit.vue'
import Exam from '@/components/basic/menu/Exam.vue'
import Events from '@/components/basic/menu/Events.vue'
import UniformServices from '@/components/basic/menu/UniformServices'
import BoardingClasses from '@/components/basic/menu/BoardingClasses.vue'
export default {
  components: {
    DishServices,
    BusServices,
    Dashboard,
    Classes,
    TimeTables,
    DraftTimeTables,
    Students,
    Teachers,
    AdvanceSetting,
    Posts,
    Settings,
    Feedback,
    // Documents,
    // ManagerDocuments,
    TuitionFee,
    DocDocAdmin,
    Balance,
    Ticket,
    Exam,
    Events,
    UniformServices,
    BoardingClasses,
  }
}
</script>

<style>
.v-navigation-drawer__content .v-list-item__title {
  font-size: 14px;
}
.v-navigation-drawer__content::-webkit-scrollbar {
  width: 0px;
}
</style>
